import React, { useState, useEffect } from "react";
import {Elements} from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import {useHistory, useParams} from "react-router-dom";
import Home from "../assets/SVG/buttons/Home-button-big.svg";
import Profile from "../assets/SVG/icons/Avatar.svg";
import Logout from "../assets/SVG/buttons/logout.svg";
import config from "../config";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import "../styles/payinvoice.css";
import * as action from "../actions";
import {
  getCustomerByUid,
  getStripeCustomer,
  getInvoiceByInvoiceId,
  getPaymentIntentById,
} from "../api";
import CheckoutForm from "../components/CheckoutForm";

const stripePromise = loadStripe(config.stripe.pub_key);


const PayInvoice = () => {
    const dispatch = useDispatch();
  const history = useHistory();
  const params = useParams();
  const user = useSelector((state) => state.user);
  const [paymentSuccess, setPaymentSuccess] = useState(false);
  const [stripeCustomer, setStripeCustomer] = useState();
  const [stripeInvoice, setStripeInvoice] = useState();
  const [stripePaymentIntent, setStripePaymentIntent] = useState();
  const [clientSecret, setClientSecret] = useState();

  useEffect(() => {
    // Check if Stripe customer exist | if not create one
    getCustomerByUid(user.uid).then(async (res) => {
      // Get the stripe customer object
      if (res.customer) {
        setStripeCustomer(res.customer);
        const stripeCustomerResp = await getStripeCustomer(res.customer?.customerId);
        setStripeCustomer(stripeCustomerResp.stripeCustomer);

        // Retrieve Invoice
        const invoiceResp = await getInvoiceByInvoiceId(params?.invoiceId);
        setStripeInvoice(invoiceResp?.invoice);

        // Retrieve Payment Intent and clientSecret
        const paymentIntentResp = await getPaymentIntentById(invoiceResp?.invoice?.payment_intent, stripeCustomerResp.stripeCustomer?.id);
        setStripePaymentIntent(paymentIntentResp?.paymentIntent);
        setClientSecret(paymentIntentResp?.paymentIntent?.client_secret);

        // pay the invoice

        // update the subscriptions
      }
    });
  }, []);

  const handleLogout = () => {
    axios
      .get(config.backend_url + "/logout")
      .then(function (response) {
        history.push("/login");
        dispatch(action.logoutUser());
      })
      .catch(function (error) {
        console.error(error);
      });
  };

  const fullRedirectToHome = () => {
    history.push("/home");
  }

  const onPaymentSuccessHandle = () => {
    setPaymentSuccess(true);
  };

    return (
      <div className="container">
        <div className="main navigation" data-testid="navigation">
          <div className="header mt-3">
          <img src={Home} alt="home" data-testid="home-btn" onClick={fullRedirectToHome}></img>
            <img
              src={user?.picture ? user.picture : Profile}
              alt="profile"
              data-testid="profile-btn"
              className="profile mt-4"
              onClick={() => history.push("/navigation")}
            ></img>
          <img src={Logout} data-testid="logout-btn" alt="logout" onClick={handleLogout}></img>
          </div>
        {(paymentSuccess) ? (
          <>
            <p className="text-center mt-3 heading" data-testid="account-heading">Account</p>
          <div className="wrapper" data-testid="wrapper">
            <div className="checkmark-container">
                <i className="checkmark">✓</i>
            </div>
              <div data-testid="success-title" className="success-title">Payment Successful</div>
            <div>Your payment was successful.</div>
            <div>You can continue using iSelfie.</div>
            <button className="success-home" onClick={fullRedirectToHome}>
              Go to Home
            </button>
          </div>
          </>
        ) : (
          <>
            <p className="text-center mt-3 heading" data-testid="pay-invoice-heading">Pay Invoice</p>
        <div>
          {clientSecret && !stripeInvoice?.paid && (
            <div className="stripe-container" id="stripe-container">
              <Elements stripe={stripePromise} options={{ clientSecret }}>
                    <CheckoutForm setPaymentSuccess={onPaymentSuccessHandle} stripeCustomerId={stripeCustomer?.id}/>
              </Elements>
            </div>
          )}
        </div>
          </>
        )}
      </div>
    </div>
  );
};

export default PayInvoice;
